// admin/src/services/permissionService.ts
//
// Singleton PermissionService for the admin app.
// Used by AuthContext to warm the cache on sign-in; consumed by usePermission().
//
// Note: TypeScript (moduleResolution:bundler) cannot pair the .mjs extension
// with its .d.ts sibling when the file lives outside the tsconfig include path.
// We use @ts-ignore to suppress the import error rather than patching tsconfig
// or duplicating the class. If this causes issues, fall back to the inline copy
// pattern used in admin/src/services/seedSystemRoles.ts.

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
// @ts-ignore — .mjs import; TS bundler module resolution can't pair with .d.ts sibling.
import { PermissionService } from '../../../shared/services/permissions.mjs';

export const permissionService = new PermissionService(db, getDoc, doc);
